export type SelectionState = {
    tagIds: string[];
    dealerIds: string[];
};

export enum SelectionActionType {
    SetTagIds = 'setTagIds',
    SetDealerIds = 'setDealerIds',
}

type SelectionTag = {
    id: string;
    userIds: string[];
};

type SelectedDealerIdsOptions = {
    tags: SelectionTag[];
    inSessionDealerIds?: string[];
    ignoreInSessionFilter?: boolean;
};

export type SelectionAction =
    | { type: SelectionActionType.SetTagIds; tagIds: string[]; addedTagDealerIds: string[] }
    | { type: SelectionActionType.SetDealerIds; dealerIds: string[] };

export const getSelectedDealerIds = (
    state: SelectionState,
    { tags, inSessionDealerIds = [], ignoreInSessionFilter = false }: SelectedDealerIdsOptions
) => {
    const taggedDealerIds = tags.filter(tag => state.tagIds.includes(tag.id)).flatMap(tag => tag.userIds);
    const selectedDealerIds = Array.from(new Set(taggedDealerIds.concat(state.dealerIds)));

    if (ignoreInSessionFilter) {
        return selectedDealerIds;
    }

    const inSessionDealerIdSet = new Set(inSessionDealerIds);

    return selectedDealerIds.filter(dealerId => !inSessionDealerIdSet.has(dealerId));
};

type SetFormValue<TValue = unknown> = (value: TValue, shouldValidate?: boolean) => void;
export type BuildSelectedDealerIds = (state: SelectionState) => string[];
export const createSyncReducer =
    ({
        setDealerIds,
        setSelectedDealerIds,
        setTagIds,
        buildSelectedDealerIds,
    }: {
        setDealerIds: SetFormValue<string[]>;
        setTagIds: SetFormValue<string[]>;
        setSelectedDealerIds: SetFormValue<string[]>;
        buildSelectedDealerIds: BuildSelectedDealerIds;
    }) =>
    (state: SelectionState, action: SelectionAction): SelectionState => {
        switch (action.type) {
            case SelectionActionType.SetTagIds: {
                const dealerIds = state.dealerIds.filter(dealerId => !action.addedTagDealerIds.includes(dealerId));
                const nextState = {
                    tagIds: action.tagIds,
                    dealerIds,
                };

                setTagIds(nextState.tagIds);
                setDealerIds(nextState.dealerIds);
                setSelectedDealerIds(buildSelectedDealerIds(nextState));

                return nextState;
            }

            case SelectionActionType.SetDealerIds: {
                const nextState = {
                    ...state,
                    dealerIds: action.dealerIds,
                };

                setDealerIds(nextState.dealerIds);
                setSelectedDealerIds(buildSelectedDealerIds(nextState));

                return nextState;
            }

            default:
                return state;
        }
    };
